import * as React from 'react'
import Hero from './components/hero'
import styles from './step-1.module.scss'
import DoodleBackground from '../../../../components/doodle-background'
import WhatYouGet from '../what-you-get'
import WaveContainer from '../../../../components/wave-container'

interface IStep1Props {
  onComplete: (company: { name: string; orgNr: string; city: string; companyCode: string }) => void
  handleClickNotYetStarted: () => void
  initialName?: string | null
}

export default function Step1({ onComplete, handleClickNotYetStarted, initialName }: IStep1Props) {
  return (
    <div>
      <Hero
        handleClickNotYetStarted={() => handleClickNotYetStarted()}
        initialName={initialName}
        key={initialName || ''}
        onSubmit={(company: { name: string; orgNr: string; city: string; companyCode: string }) => onComplete(company)}
      />
      <WaveContainer className={styles.content}>
        <DoodleBackground variant="topRight" />
        <div className={styles.whatyouget}>
          <WhatYouGet />
        </div>
      </WaveContainer>
    </div>
  )
}
